import { render, staticRenderFns } from "./MonitorAcoes.vue?vue&type=template&id=4101fd56&"
import script from "./MonitorAcoes.vue?vue&type=script&lang=js&"
export * from "./MonitorAcoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports